<template>
    <div>
        <p class="label">{{ label }}</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
    import NewsletterService from '@/services/newsletter.service.js';


  export default {
    name: "NewsletterMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array,
      label: { type: String, default: 'Opt-in'}
    },
    data() {
      return {
        items: [],
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      async loadListItem() {
        const _this = this;

        const {data} = await NewsletterService.getList();

        _this.items = data;
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
